
import { useState } from "react";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/lib/supabase";

interface AuthHandlerProps {
  prompt: string;
  setIsLoading: (loading: boolean) => void;
  safeSetItem: (key: string, value: string) => boolean;
  safeRemoveItem: (key: string) => boolean;
  toast: ReturnType<typeof useToast>["toast"];
}

export const handleGoogleSignIn = async ({
  prompt,
  setIsLoading,
  safeSetItem,
  safeRemoveItem,
  toast
}: AuthHandlerProps) => {
  try {
    setIsLoading(true);
    console.log('Starting Google Sign In process with prompt:', prompt);
    
    if (prompt) {
      console.log('Saving prompt before auth:', prompt);
      if (!safeSetItem('pendingMeetingPrompt', prompt)) {
        console.error('Failed to save prompt before auth');
      }
    }

    const { data, error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: window.location.hostname === 'localhost' 
          ? 'http://localhost:5173/auth/callback'
          : 'https://meetalfie.ai/auth/callback',
        scopes: 'openid email profile https://www.googleapis.com/auth/contacts.readonly https://www.googleapis.com/auth/calendar.events',
        queryParams: {
          prompt: 'consent select_account',
          access_type: 'offline'
        }
      }
    });

    console.log('Auth response:', { data, error });

    if (error) {
      console.error("Auth error:", error);
      safeRemoveItem('pendingMeetingPrompt');
      toast({
        title: "Authentication Error",
        description: error.message,
        variant: "destructive",
      });
    }
  } catch (error) {
    console.error("Unexpected error during sign in:", error);
    safeRemoveItem('pendingMeetingPrompt');
    toast({
      title: "Error",
      description: "An unexpected error occurred",
      variant: "destructive",
    });
  } finally {
    setIsLoading(false);
  }
};
